import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { MillSizeSelector } from "./MillSizeSelector";
import { RollApplicationSelector } from "./RollApplicationSelector";
import { RollMaterialSelector } from "./RollMaterialSelector";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";

interface RollsBlankToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	millSizeId: number | null;
	onMillSizeChange: (value: number | null) => void;
	rollApplicationId: number | null;
	onRollApplicationChange: (value: number | null) => void;
	rollMaterialId: number | null;
	onRollMaterialChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const RollsBlankToolbar = ({
	search,
	onSearchChange,
	millSizeId,
	onMillSizeChange,
	rollApplicationId,
	onRollApplicationChange,
	rollMaterialId,
	onRollMaterialChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: RollsBlankToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 2,
				mb: 1,
				flexWrap: "wrap",
			}}
		>
			<TextField
				size="small"
				placeholder="Search Name..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 180 }}
			/>

			<MillSizeSelector
				value={millSizeId}
				onChange={onMillSizeChange}
				includeAll
				size="small"
			/>

			<RollApplicationSelector
				value={rollApplicationId}
				onChange={onRollApplicationChange}
				includeAll
				size="small"
			/>

			<RollMaterialSelector
				value={rollMaterialId}
				onChange={onRollMaterialChange}
				includeAll
				size="small"
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				ADD ROLL BLANK
			</Button>
		</Box>
	);
};
